module.exports = __webpack_public_path__ + "img/img-5.de3ed7e9.png";